import { render, staticRenderFns } from "./detainment.vue?vue&type=template&id=4911fbc1&scoped=true&"
import script from "./detainment.vue?vue&type=script&lang=js&"
export * from "./detainment.vue?vue&type=script&lang=js&"
import style0 from "./detainment.vue?vue&type=style&index=0&id=4911fbc1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4911fbc1",
  null
  
)

export default component.exports